import Phaser from 'phaser';
import { createPremiumMissionMap } from '../systems/PremiumMissionMap';
import { ProgressData as PlayerData } from '../systems/ProgressData';
import { GAME_MODE, getGameMode } from '../systems/GameMode';
import { formatScore } from '../util/numberFormat';
import { CHALLENGES_PER_MISSION } from '../planets/additionMissions';
import { DIVISION_MISSIONS } from '../planets/divisionMissions';
import { mountMenu, element, button, header, modeBadge, go } from '../util/menuUI';

export class DivisionMissionsScene extends Phaser.Scene {
  constructor() { super('DivisionMissionsScene'); }

  create() {
    const root = mountMenu(this);
    root.classList.add('tmag-mission-map', 'tmag-division');
    const isPractice = getGameMode(this.registry) === GAME_MODE.PRACTICE;
    if (isPractice) root.classList.add('tmag-practice-map');
    const done = PlayerData.countMissionsComplete('division', DIVISION_MISSIONS.length);
    header(
      root,
      'SISTEMA ESTELAR DE LA DIVISIÓN',
      isPractice ? 'Elige un planeta para practicar' : `Elige un planeta para explorar · ${done} / ${DIVISION_MISSIONS.length} completados`,
      '← GALAXIA',
      () => go(this, 'GalaxyScene'),
    );
    root.querySelector('.tmag-menu-header')?.append(modeBadge(this));

    const premium = createPremiumMissionMap(this, root);
    const grid = element('div', 'tmag-grid');
    DIVISION_MISSIONS.forEach(m => {
      const unlocked = isPractice || PlayerData.isMissionUnlocked('division', m.index);
      const complete = !isPractice && PlayerData.isMissionComplete('division', m.index);
      const attempted = !isPractice && !!PlayerData.getMissionAttempt('division', m.index);
      const card = button('', () => {
        if (premium.guard(card, m.index)) return;
        go(this, 'MissionScene', () => {
        this.registry.set('currentPlanet', 'division');
        this.registry.set('currentMissionIndex', m.index);
        this.registry.set('currentMissionData', m);
        this.registry.get('audio')?.playCollect();
        });
      }, `tmag-card${complete ? ' tmag-complete' : ''}`);
      card.disabled = !unlocked;
      card.style.setProperty('--planet-color', '#75f0ff');
      card.append(element('h2', '', `PLANETA ${m.num}`));
      card.append(element('p', 'tmag-skill', m.skill));
      if (!isPractice) {
        card.append(element('span', 'tmag-card-info', `${CHALLENGES_PER_MISSION} retos de división`));
        const best = PlayerData.getMissionBest('division', m.index);
        card.append(element('span', 'tmag-card-info', best ? `★ Mejor: ${formatScore(best)} pts` : '★ Mejor: —'));
        card.append(element('span', 'tmag-status', complete ? '✓ DOMINADA' : unlocked ? attempted ? '↻ PRACTICAR' : 'DISPONIBLE' : '🔒 BLOQUEADA'));
      }
      const status = card.querySelector('.tmag-status') || element('span', 'tmag-status', 'DISPONIBLE');
      if (!status.isConnected) card.append(status);
      premium.register(card, m.index, unlocked, status);
      grid.append(card);
    });
    root.append(grid);
  }
}
